<template>
	<main id="app" v-bind:data-authenticated="$store.getters.authenticated">
		<LayoutPrimary />

		<!-- Global alert / confirm / prompt dialog (driven by Manager/Alert via the event bus) -->
		<ChalkyUtilityAlertPrompt ref="alertPrompt" />
	</main>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import { Component, Vue } from 'vue-property-decorator';

	@Component
	export default class App extends Vue {
		/**
		 * @return void
		 */
		public mounted(): void {
			this.setupDialog();
		}

		/**
		 * Bridge Manager/Alert event-bus dispatches to the ChalkyUtilityAlertPrompt
		 * component so any code can call this.$alert.alert/confirm/prompt(...).
		 *
		 * @return void
		 */
		protected setupDialog(): void {
			// Handle alert dialogs
			ChalkySticks.Core.Event.Bus.on('dialog:alert', async (e: any) => {
				const message = e.data.message || 'Thank you for using ChalkySticks!';
				const title = e.data.title || 'Alert';
				const alertPrompt = this.$refs.alertPrompt as any;

				await alertPrompt.alert(message, title);
				alertPrompt.close();
			});

			// Handle confirm dialogs
			ChalkySticks.Core.Event.Bus.on('dialog:confirm', async (e: any) => {
				const message = e.data.message || '';
				const title = e.data.title || 'Confirm';
				const callback = e.data.callback;
				const alertPrompt = this.$refs.alertPrompt as any;

				const result = await alertPrompt.confirm(message, title);

				if (typeof callback === 'function') {
					callback(result);
				}

				alertPrompt.close();
			});

			// Handle prompt dialogs
			ChalkySticks.Core.Event.Bus.on('dialog:prompt', async (e: any) => {
				const message = e.data.message || '';
				const title = e.data.title || 'Prompt';
				const options = e.data.options || [];
				const callback = e.data.callback;
				const alertPrompt = this.$refs.alertPrompt as any;

				const value = await alertPrompt.prompt(message, title, options);

				if (typeof callback === 'function') {
					callback(value);
				}

				alertPrompt.close();
			});
		}
	}
</script>

<style lang="scss">
	#app {
		height: 100%;
	}
</style>
